export default __webpack_public_path__ + "static/media/logoKahshBlogMedium.e4409cd2.bin";